var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWomanWorking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    cx: 85,
    cy: 85,
    r: 85,
    transform: "translate(-0.301 0.311)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_15",
    "data-name": "Mask Group 15",
    transform: "translate(0.301 -0.311)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25803",
    "data-name": "Group 25803",
    transform: "translate(9.811 30.224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25790",
    "data-name": "Group 25790",
    transform: "translate(0 34.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34498",
    "data-name": "Path 34498",
    d: "M583.384,126.982l-19.634-.614.049-2.295.037-1.436.061-2.835.049-2,.086-3.313.037-1.951.061-2.7.049-1.8.061-2.761.012-.724.11-4.565,16.873.307.319,3.939.147,1.828.2,2.516.16,2.013.147,1.718.233,2.945.209,2.565.221,2.737.135,1.657.11,1.473Z",
    transform: "translate(-563.749 -98.604)",
    fill: "#fd8860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34499",
    "data-name": "Path 34499",
    d: "M567.749,102.066V99.028l8.9-.169.614,3.375Z",
    transform: "translate(-562.841 -98.86)",
    fill: "#ffad80",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25789",
    "data-name": "Group 25789",
    transform: "translate(0.049 5.504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25784",
    "data-name": "Group 25784",
    transform: "translate(0.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34500",
    "data-name": "Path 34500",
    d: "M581.611,105.3c-5.817-.307-11.621-.724-17.462-.785l.012-.724a156.475,156.475,0,0,1,17.3-.319Z",
    transform: "translate(-564.149 -103.345)",
    fill: "#ffe7d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25785",
    "data-name": "Group 25785",
    transform: "translate(0.331 3.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34501",
    "data-name": "Path 34501",
    d: "M581.988,109.127a156.1,156.1,0,0,1-17.929-.749l.049-1.8a104.271,104.271,0,0,1,17.72.54Z",
    transform: "translate(-564.059 -106.417)",
    fill: "#ffe7d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25786",
    "data-name": "Group 25786",
    transform: "translate(0.233 7.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34502",
    "data-name": "Path 34502",
    d: "M582.386,113.02a150.387,150.387,0,0,1-18.407-.761l.037-1.951a111.708,111.708,0,0,1,18.137-.233Z",
    transform: "translate(-563.979 -109.807)",
    fill: "#ffe7d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25787",
    "data-name": "Group 25787",
    transform: "translate(0.098 13.476)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34503",
    "data-name": "Path 34503",
    d: "M582.841,117.294c-2.859,0-5.743-.147-8.6-.233a91.4,91.4,0,0,1-10.369-.515l.049-2a96.518,96.518,0,0,1,11.462-.086c2.417.025,4.835.025,7.24.1Z",
    transform: "translate(-563.869 -114.326)",
    fill: "#ffe7d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25788",
    "data-name": "Group 25788",
    transform: "translate(0 17.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34504",
    "data-name": "Path 34504",
    d: "M583.1,119.622a101.614,101.614,0,0,1-19.315.393l.037-1.436a99.1,99.1,0,0,1,19.168-.429Z",
    transform: "translate(-563.789 -117.854)",
    fill: "#ffe7d4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25795",
    "data-name": "Group 25795",
    transform: "translate(27.304 14.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34505",
    "data-name": "Path 34505",
    d: "M586.736,119.373,586,84.727l51.231-2.211,1.843,37.594Z",
    transform: "translate(-585.999 -82.516)",
    fill: "#ffe7d4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25791",
    "data-name": "Group 25791",
    transform: "translate(4.607 8.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34506",
    "data-name": "Path 34506",
    d: "M589.938,94.618l-.184-5.344h6.082l.369,5.16Z",
    transform: "translate(-589.753 -89.274)",
    fill: "#334682"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34507",
    "data-name": "Path 34507",
    d: "M589.938,101.376l-.184-5.344h6.082l.369,5.16Z",
    transform: "translate(-589.753 -87.739)",
    fill: "#1f2d59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34508",
    "data-name": "Path 34508",
    d: "M589.938,108.134l-.184-5.344h6.082l.369,5.16Z",
    transform: "translate(-589.753 -86.204)",
    fill: "#101830"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25792",
    "data-name": "Group 25792",
    transform: "translate(15.664 8.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34509",
    "data-name": "Path 34509",
    d: "M598.948,94.618l-.184-5.344h6.081l.369,5.16Z",
    transform: "translate(-598.764 -89.274)",
    fill: "#ffad80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34510",
    "data-name": "Path 34510",
    d: "M598.948,101.376l-.184-5.344h6.081l.369,5.16Z",
    transform: "translate(-598.764 -87.739)",
    fill: "#fd8860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34511",
    "data-name": "Path 34511",
    d: "M598.948,108.134l-.184-5.344h6.081l.369,5.16Z",
    transform: "translate(-598.764 -86.204)",
    fill: "#f46440"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25794",
    "data-name": "Group 25794",
    transform: "translate(27.525 5.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25793",
    "data-name": "Group 25793"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34512",
    "data-name": "Path 34512",
    d: "M629.438,114.392l-3.569-.118-1.547-.044h-.015l-2.3-.074-1.032-.029-10.836-.34c0-.5-1.711-26.67-1.711-26.67l6.708.044,3.3.015,10.128.074.309,9.612.531,16.395Z",
    transform: "translate(-608.429 -87.117)",
    fill: "#ffad80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34513",
    "data-name": "Path 34513",
    d: "M628.3,111.583a8.955,8.955,0,0,1-1.637.692,7.506,7.506,0,0,1-1.9.325,6.808,6.808,0,0,1-1.547-.044H623.2a8.02,8.02,0,0,1-2.255-.62c-.265-.118-.531-.25-.8-.4l.723-.133L622,111.2a6.263,6.263,0,0,1-1.268-.265,5.561,5.561,0,0,1-1.047-.383,10.542,10.542,0,0,1-3.052-1.976,1.012,1.012,0,0,1-.191-.162,9.311,9.311,0,0,1-3.111-5.839,5.857,5.857,0,0,1,.206-2.079A7.021,7.021,0,0,1,616.7,96.6a9.569,9.569,0,0,1,1.606-.811,9.194,9.194,0,0,1,1.254-.443,17.952,17.952,0,0,1,1.945-.5,10,10,0,0,1,5.957.177,3.122,3.122,0,0,1,.309.162Z",
    transform: "translate(-607.319 -85.443)",
    fill: "#f46440"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34514",
    "data-name": "Path 34514",
    d: "M617.987,87.168l.928,9.848h-.486a31.08,31.08,0,0,1-4.822-.339,3.769,3.769,0,0,1-2.8-1.385c-.87-1.341-.1-3.184.8-4.511a20.331,20.331,0,0,1,3.081-3.627Z",
    transform: "translate(-607.976 -87.109)",
    fill: "#243466"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34515",
    "data-name": "Path 34515",
    d: "M618.965,100.048c.015,0,.015,0,.03.015l.782,8.256a4.636,4.636,0,0,0-1.931-.8,7.921,7.921,0,0,0-1.017-.088,13.375,13.375,0,0,1-2.035-.147,2.714,2.714,0,0,1-2.27-1.917,3.691,3.691,0,0,1,.147-1.7,8.774,8.774,0,0,1,.855-2.241,3.558,3.558,0,0,1,1.887-1.768C616.563,99.266,617.786,99.724,618.965,100.048Z",
    transform: "translate(-607.51 -84.302)",
    fill: "#243466"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34516",
    "data-name": "Path 34516",
    d: "M618.528,107.779l-.1-1.091a3.532,3.532,0,0,1,1.017,1.165,1.4,1.4,0,0,1,.133.309h.015c.044.162.088.309.118.472a3.282,3.282,0,0,1,.074.53,3.41,3.41,0,0,1-.044.546l-1.032-.029Z",
    transform: "translate(-606.159 -82.671)",
    fill: "#243466"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34517",
    "data-name": "Path 34517",
    d: "M623.167,99.233a2.954,2.954,0,0,1-2.241,2.064,6.109,6.109,0,0,1-3.037-.25l-.5-5.41-.044-.443c.428-.015.87-.028,1.3,0h.015a6.574,6.574,0,0,1,2.432.458A3.349,3.349,0,0,1,623.167,99.233Z",
    transform: "translate(-606.404 -85.286)",
    fill: "#243466"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34518",
    "data-name": "Path 34518",
    d: "M620.226,103.925l1.233-1.593",
    transform: "translate(-605.749 -83.661)",
    fill: "none",
    stroke: "#101830",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34519",
    "data-name": "Path 34519",
    d: "M622.56,103.625q.679-.734,1.4-1.426",
    transform: "translate(-605.219 -83.691)",
    fill: "none",
    stroke: "#101830",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34520",
    "data-name": "Path 34520",
    d: "M620.94,105.8l.368-.553",
    transform: "translate(-605.587 -83)",
    fill: "none",
    stroke: "#101830",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34521",
    "data-name": "Path 34521",
    d: "M622.34,106.945a2.139,2.139,0,0,0,.556-.551",
    transform: "translate(-605.269 -82.738)",
    fill: "none",
    stroke: "#101830",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34522",
    "data-name": "Path 34522",
    d: "M623.8,104.978l.6-.688",
    transform: "translate(-604.937 -83.216)",
    fill: "none",
    stroke: "#101830",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34523",
    "data-name": "Path 34523",
    d: "M618.647,108.018a4.218,4.218,0,0,0,.718-.877",
    transform: "translate(-606.108 -82.569)",
    fill: "none",
    stroke: "#101830",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34524",
    "data-name": "Path 34524",
    d: "M618.788,105.891a1.9,1.9,0,0,1,.673-.8",
    transform: "translate(-606.076 -83.034)",
    fill: "none",
    stroke: "#101830",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34525",
    "data-name": "Path 34525",
    d: "M620.085,108.55l.928-.854",
    transform: "translate(-605.781 -82.443)",
    fill: "none",
    stroke: "#101830",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34526",
    "data-name": "Path 34526",
    d: "M616.472,108.341a8.693,8.693,0,0,1,.816-.844",
    transform: "translate(-606.602 -82.488)",
    fill: "none",
    stroke: "#101830",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25800",
    "data-name": "Group 25800",
    transform: "translate(25.57 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25796",
    "data-name": "Group 25796",
    transform: "translate(41.672 54.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34527",
    "data-name": "Path 34527",
    d: "M664.2,137.7a82.047,82.047,0,0,0-10.29-3.172c-1.879,9.4-14.131,18.055-32.647,12.857-1.584-.729-2.717,3.81-2.717,3.81s26.952,13.674,41.263-4.425a36.678,36.678,0,0,0,5.237-8.73C664.762,137.93,664.48,137.813,664.2,137.7Z",
    transform: "translate(-618.544 -110.721)",
    fill: "#5e2f26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34528",
    "data-name": "Path 34528",
    d: "M656.144,115.128c-5.373.642-7.11,23.037-11.8,31.076.1-.431,11.084,4.4,10.385,5.527,0,0,7.7-6.808,8.553-12.5C663.284,139.228,658.037,115.1,656.144,115.128Z",
    transform: "translate(-612.683 -115.128)",
    fill: "#1f2d59"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34529",
    "data-name": "Path 34529",
    d: "M655.381,111.141c.153.46-.92,11.2-.92,11.2l10.277-2.148-2.3-13.5",
    transform: "translate(-568.714 -62.243)",
    fill: "#6d392f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34530",
    "data-name": "Path 34530",
    d: "M653.408,120.945l3.97-5.726s5.931-2.556,8.078-1.431-4.909,17.077-4.909,17.077l-5.829,2.659-2.352-6.341Z",
    transform: "translate(-569.19 -60.696)",
    fill: "#fd8860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34531",
    "data-name": "Path 34531",
    d: "M597.034,218.163s-4.533,4.326-4.269,4.326,6.682.79,6.682.79l4.307-2.637-.879-3.429",
    transform: "translate(-582.73 -37.138)",
    fill: "#6d392f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34532",
    "data-name": "Path 34532",
    d: "M665.83,172.528l-30.495,18.191c-3.216,1.919-6.85,4.56-6.71,8.3a15.8,15.8,0,0,0,1.154,4.192c1.666,5.116.616,10.757-1.384,15.753s-4.9,9.577-7.124,14.479a57.349,57.349,0,0,0-3.711,11.085,3.427,3.427,0,0,1-.783,1.8,3.271,3.271,0,0,1-2.1.648c-1.951.124-10.7,1.287-8.676.185,6.154-2.508,7.526-20.2,8.213-30.536.679-10.206.264-20.493,1.659-30.626.511-3.711,1.377-7.613,4-10.291a18.175,18.175,0,0,1,5.95-3.632,116.888,116.888,0,0,1,16.055-5.609",
    transform: "translate(-579.79 -48.665)",
    fill: "#5e2f26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34533",
    "data-name": "Path 34533",
    d: "M586.164,228.057c2.84-2.469,6.039-4.494,8.932-6.9.138-.115.272-.237.409-.353,3.155,1.114,7.321.066,9.931-2.106q.493,1.773.989,3.545a1.363,1.363,0,0,1,.07.684,1.339,1.339,0,0,1-.513.657,33.49,33.49,0,0,1-21.284,7.633C584.249,230.06,585.228,228.872,586.164,228.057Z",
    transform: "translate(-584.586 -36.801)",
    fill: "#243466"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34534",
    "data-name": "Path 34534",
    d: "M609.471,240.526c-.493-.364,2.608-8.9,3.835-31.6a384.274,384.274,0,0,1,4.142-39.729l21.628-1.381,15.493,15.8-8.13-.307s-15.646,9.971-17.333,12.885,3.068,9.51,4.295,18.1,3.221,27.611,3.221,27.611S622.969,250.5,609.471,240.526Z",
    transform: "translate(-578.945 -48.358)",
    fill: "#e35430"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34535",
    "data-name": "Path 34535",
    d: "M625.719,244.316c5.765-42.7-7.427-58.96-2.259-62.191,9.354,2.264,18.216,3.791,27.529,6.083.675.169,1.365.324,2.04.479,10.086,2.181,21.451,1.787,29.61-4.529,8.735-6.765,11.76-18.934,10.55-29.933l-2.476-5.163-.168-.352a101.609,101.609,0,0,0-16.8-.59c-1.73.07-3.459.211-5.176.379a2.269,2.269,0,0,0-1.28.394,2.156,2.156,0,0,0-.562.985c-1.168,3.094-2.35,6.189-3.517,9.283a110.064,110.064,0,0,0-17.091-.113,111.606,111.606,0,0,0-28.739,5.866,14.346,14.346,0,0,0-4.571,2.265c-2.32,1.9-3.348,4.923-4.122,7.821-3.8,14.15-7.568,55.463-12.448,58.882C596.2,234.375,624.4,245.445,625.719,244.316Z",
    transform: "translate(-581.938 -52.859)",
    fill: "#f46440"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34536",
    "data-name": "Path 34536",
    d: "M597.194,237.5c3.884-2.3,8.156-4.09,11.805-6.688a13.537,13.537,0,0,0,10.653.026l-.011,7.433q-11.626.284-23.248.663C596.076,238.405,596.671,237.807,597.194,237.5Z",
    transform: "translate(-581.924 -34.05)",
    fill: "#243466"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34537",
    "data-name": "Path 34537",
    d: "M672.481,184.818c-13.6,20.3-17.616,45.3-32.132,65.039",
    transform: "translate(-571.919 -44.497)",
    fill: "none",
    stroke: "#6199ba",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34538",
    "data-name": "Path 34538",
    d: "M637.919,185.082a655.6,655.6,0,0,1,29.609,64.654",
    transform: "translate(-572.471 -44.437)",
    fill: "none",
    stroke: "#6199ba",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34539",
    "data-name": "Path 34539",
    d: "M637.648,182.4l37.576.407.268,6.042L637.45,191.3Z",
    transform: "translate(-572.578 -45.047)",
    fill: "#101830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34540",
    "data-name": "Path 34540",
    d: "M659.475,161.721c-1.252-.409-2.5-.838-3.723-1.314a2.715,2.715,0,0,1-1.344-.872,2.768,2.768,0,0,1-.355-1.168q-.882-6.071-1.766-12.143c-1.236-8.493-2.384-17.6,1.406-25.3a8.7,8.7,0,0,0,.366,4.085,3.269,3.269,0,0,0,3.2,2.148c1.667-.221,2.588-2,3.232-3.549l3.895-9.384.967-.648c16.407,2.441,18.338,38.659,15.182,46.367A43.564,43.564,0,0,1,659.475,161.721Z",
    transform: "translate(-569.476 -60.678)",
    fill: "#243466"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34541",
    "data-name": "Path 34541",
    d: "M668.809,117.143a4.511,4.511,0,0,1,4.489-.576,8.415,8.415,0,0,1,3.532,3.118c2.187,3.14,3.205,6.938,3.918,10.7a81.733,81.733,0,0,1,.766,25.574c-.259,2.014-.681,4.188-2.2,5.533a7.03,7.03,0,0,1-3.543,1.465c-4.41.74-8.9-.394-13.225-1.518q-6.807-1.767-13.607-3.562a9.8,9.8,0,0,1-4.8-2.291c-1.233-1.307-1.525-3.673-.118-4.792a147.878,147.878,0,0,0,20.508.755,3,3,0,0,0,1.674-.39c.8-.567.858-1.713.836-2.695-.148-6.774-.281-13.549-.445-20.323C666.494,124.165,666.319,119.148,668.809,117.143Z",
    transform: "translate(-571.299 -60.079)",
    fill: "#6d392f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25798",
    "data-name": "Group 25798",
    transform: "translate(75.26 23.915)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25797",
    "data-name": "Group 25797"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34542",
    "data-name": "Path 34542",
    d: "M655.636,90.576c3.339,1.22,7.039.915,10.544,1.125,1.784.106,3.607.268,5.431.41a14.316,14.316,0,0,1,.7,2.168c1.225,5.274-.29,10.9-3.065,15.547-3.819,4.9-6.9,7.135-12.184,7.56-11.626-.254-10.918-12.636-11.131-20.579s1.99-6.791,1.99-6.791S652.859,90.96,655.636,90.576Z",
    transform: "translate(-645.915 -89.959)",
    fill: "#6d392f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34543",
    "data-name": "Path 34543",
    d: "M646.371,98.1a2.322,2.322,0,0,1,3.126.052",
    transform: "translate(-645.812 -88.242)",
    fill: "none",
    stroke: "#101830",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34544",
    "data-name": "Path 34544",
    d: "M652.979,97.938a5.813,5.813,0,0,1,2.659-.944,3.243,3.243,0,0,1,2.587.953",
    transform: "translate(-644.311 -88.362)",
    fill: "none",
    stroke: "#101830",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34545",
    "data-name": "Path 34545",
    d: "M649.979,107.4a3.769,3.769,0,0,0,4.45-.222,6.916,6.916,0,0,1-1.865,2.794,1.554,1.554,0,0,1-1.516.2,1.348,1.348,0,0,1-.444-.309,2.58,2.58,0,0,1-.455-2.163",
    transform: "translate(-644.992 -86.047)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34546",
    "data-name": "Path 34546",
    d: "M649.843,97.536a10.074,10.074,0,0,1,.474,6.485,4.2,4.2,0,0,1-1.114,2.464,14.74,14.74,0,0,0,3.859,1.259",
    transform: "translate(-569.908 -64.323)",
    fill: "none",
    stroke: "#57261d",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34547",
    "data-name": "Path 34547",
    d: "M654.423,101.928l-.072-.023",
    transform: "translate(-568.739 -63.33)",
    fill: "none",
    stroke: "#101830",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34548",
    "data-name": "Path 34548",
    d: "M647.787,101.7l.072.023",
    transform: "translate(-570.23 -63.376)",
    fill: "none",
    stroke: "#101830",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34549",
    "data-name": "Path 34549",
    d: "M636.248,142.693c0,.46,2.3,7.67-5.829,8.743s-6.443-8.59-6.443-8.59Z",
    transform: "translate(-575.671 -54.065)",
    fill: "#101830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34550",
    "data-name": "Path 34550",
    d: "M633.725,143.733a9.015,9.015,0,0,1,4.048.256,2.337,2.337,0,0,1,1.614,1.212,2.649,2.649,0,0,1-.485,2.625,3.583,3.583,0,0,1-2.09,1.052,10.279,10.279,0,0,1-4.769-.172",
    transform: "translate(-573.806 -53.856)",
    fill: "none",
    stroke: "#101830",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34551",
    "data-name": "Path 34551",
    d: "M646.72,146.01a19.542,19.542,0,0,0-3.624-4.345,29.844,29.844,0,0,1-3.688.774,4.26,4.26,0,0,1-3.26-.74,2.427,2.427,0,0,0,1.75,2.683,4.214,4.214,0,0,0,1.541.162,29.033,29.033,0,0,0-3.528.887,1.033,1.033,0,0,0-.463.248.728.728,0,0,0,.306,1.054,2.1,2.1,0,0,0,1.242.1c-.2.437-.816.56-1.027.994a.947.947,0,0,0,.558,1.178,2.738,2.738,0,0,0,1.435.09c-.75.892-.136,2.379.908,2.9a5.1,5.1,0,0,0,3.422.07,25.608,25.608,0,0,0,5.8-2.143Z",
    transform: "translate(-573.062 -54.299)",
    fill: "#6d392f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34552",
    "data-name": "Path 34552",
    d: "M662.353,119.585c0,.714-.767,26.927-.767,26.927l17.18,1.07s-.614-29.067-10.737-31.741C660.052,115.127,662.353,119.585,662.353,119.585Z",
    transform: "translate(-567.096 -60.182)",
    fill: "#243466"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34553",
    "data-name": "Path 34553",
    d: "M654.614,114.562l10.124-1.994,1.074,1.994v11.351l-4.6,6.289-6.749.614-3.375-2.608,1.534-8.743Z",
    transform: "translate(-569.48 -60.908)",
    fill: "#243466"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34554",
    "data-name": "Path 34554",
    d: "M658.952,93.506c.661-.639,1.885,0,2.075.9a3.218,3.218,0,0,1-.879,2.522,7.184,7.184,0,0,0-1.493,2.295.658.658,0,0,0-.028.329c.049.2.248.315.427.41l3,1.588a.586.586,0,0,1,.309.279.6.6,0,0,1-.107.464,8.653,8.653,0,0,0-1.006,3.6,1.041,1.041,0,0,0,.193.8c.374.385,1.061.018,1.284-.471s.211-1.068.47-1.539a1.782,1.782,0,0,1,1.983-.768,2.585,2.585,0,0,1,1.63,1.5,3.33,3.33,0,0,1-2.756,4.652,1.122,1.122,0,0,0-.545.126.933.933,0,0,0-.3.5,13.39,13.39,0,0,0-.515,6.374c1.079-2.513,4.124-3.377,6.354-4.961a10.267,10.267,0,0,0,4.14-9.52,3.453,3.453,0,0,1-.02-1.465,2.515,2.515,0,0,1,1.751-1.432,6.815,6.815,0,0,0,2.171-.871,2.363,2.363,0,0,0-1.057-4.194,2.289,2.289,0,0,1-.937-.233c-.661-.452-.25-1.512.344-2.049s1.387-1.061,1.382-1.862c-.006-1.038-1.352-1.5-2.381-1.361-.794.11-1.714.371-2.318-.158-.727-.636-.361-1.838-.7-2.744a1.87,1.87,0,0,0-2.622-.9,3.083,3.083,0,0,1-.469.287c-.7.277-1.36-.436-1.847-1.011-1.152-1.363-3.049-2.422-4.69-1.718a7.592,7.592,0,0,0-2.367,2.214,3.04,3.04,0,0,1-2.833,1.264",
    transform: "translate(-568.228 -67.703)",
    fill: "#101830"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25799",
    "data-name": "Group 25799",
    transform: "translate(32.953 88.919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34555",
    "data-name": "Path 34555",
    d: "M618.6,148.369c-1.956,1.67-1.423,3.546-.347,4.554.844-.136.229-2.038.7-2.75.631-1.319,3.085-.193,5.141-.918.537-.188-.768-3.405-.768-3.405l-6.494-2.783a.961.961,0,0,0-.679-.107.92.92,0,0,0-.387.334,21.637,21.637,0,0,0-2.582,4.171",
    transform: "translate(-611.042 -142.93)",
    fill: "#5e2f26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34556",
    "data-name": "Path 34556",
    d: "M616.124,145.51a6.738,6.738,0,0,0-.509,6.578c.227.475.983.9,1.156.4,0,0-.469-4.38,1.635-4.27s-.329-2.1-.329-2.1Z",
    transform: "translate(-610.633 -142.344)",
    fill: "#5e2f26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34557",
    "data-name": "Path 34557",
    d: "M613.8,146.491a4.239,4.239,0,0,0,1.777,5.6s.742.474.693-.541a29.2,29.2,0,0,1,1.182-4.907l-.524-1.339-1.76.054Z",
    transform: "translate(-611.004 -142.39)",
    fill: "#5e2f26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34558",
    "data-name": "Path 34558",
    d: "M615.41,147.319c-2.646.719-3.032,4.158-3.689,3.846s-.076-3.256.818-4.6,1.914-2.849,3.437-3.386c.391-.139,1.031.574,1.1.78A29.652,29.652,0,0,1,615.41,147.319Z",
    transform: "translate(-611.439 -142.878)",
    fill: "#5e2f26"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34559",
    "data-name": "Path 34559",
    d: "M662.569,94.7c-.287,1.066-2.125,1.1-3.3.639s-2.46-1.181-3.666-.768c-.9.309-1.508,1.21-2.484,1.222-1.162.015-1.785-1.223-2.889-1.531a5.167,5.167,0,0,0-1.707-.021c-2.954.194-5.952-1.369-7.059-3.68a4.054,4.054,0,0,1,.088-3.912,4.221,4.221,0,0,1,3.944-1.833c.631.076,1.35.282,1.851-.05.761-.507.12-1.493-.269-2.241-1.138-2.187.886-4.923,3.643-5.489a8.072,8.072,0,0,1,7.4,2.622,12.416,12.416,0,0,0,1.809,2.005,2.774,2.774,0,0,0,2.755.422c1.039-.533,1.077-1.779,1.707-2.656,1.022-1.423,3.582-1.6,5.257-.715a6.74,6.74,0,0,1,3.1,4.113,3.806,3.806,0,0,1,.229,1.72c-.224,1.447-1.849,2.61-1.763,4.067a3.931,3.931,0,0,0,1.746,2.5,6.19,6.19,0,0,1,2.129,2.328,1.735,1.735,0,0,1-1.405,2.314",
    transform: "translate(-571.771 -69.01)",
    fill: "#101830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34560",
    "data-name": "Path 34560",
    d: "M663.963,85.16c-2.146-.774-4.391-1.612-5.892-3.332s-1.924-4.609-.283-6.2c1.484-1.435,3.929-1.216,5.819-.385a2.471,2.471,0,0,0,1.579.344c.925-.248,1.112-1.437,1.475-2.324.777-1.892,3-2.858,5.044-2.793a15.23,15.23,0,0,1,5.818,1.811,11.4,11.4,0,0,1,3.988,2.594,3.9,3.9,0,0,1,.679,4.429c-.3.484-.761,1.055-.464,1.541a1.233,1.233,0,0,0,.6.423c1.957.842,4,1.761,5.274,3.47a9.447,9.447,0,0,1,1.468,3.438,10.011,10.011,0,0,1,.079,5.338,5.018,5.018,0,0,1-3.711,3.55c-1.3.216-2.986-.056-3.608,1.1a3.9,3.9,0,0,0-.291,1.12c-.539,2.719-3.539,4.524-6.292,4.2a8.256,8.256,0,0,1-6.229-4.945",
    transform: "translate(-568.197 -70.47)",
    fill: "#101830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34561",
    "data-name": "Path 34561",
    d: "M659.124,81.546s4.909-1.994,9.664,4.448,3.807,15.866,3.807,15.866,6.778-13.1-1.812-19.394S659.124,81.546,659.124,81.546Z",
    transform: "translate(-567.655 -68.44)",
    fill: "#f46440"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25801",
    "data-name": "Group 25801",
    transform: "translate(5.242 108.963)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34562",
    "data-name": "Path 34562",
    d: "M568.021,256.479q11.02-49.145,26.261-97.215,6.882,48.415,13.762,96.827",
    transform: "translate(-568.021 -159.264)",
    fill: "none",
    stroke: "#89bddb",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34563",
    "data-name": "Path 34563",
    d: "M644.554,256.812q6.733-48.234,17.854-95.72,11.552,47.645,23.106,95.288",
    transform: "translate(-550.637 -158.849)",
    fill: "none",
    stroke: "#89bddb",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34564",
    "data-name": "Path 34564",
    d: "M572.982,155.381l120.845-.9.753,9.495-121.83-4.295Z",
    transform: "translate(-561.705 -51.389)",
    fill: "#101830"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25802",
    "data-name": "Group 25802",
    transform: "translate(13.575 72.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34565",
    "data-name": "Path 34565",
    d: "M637.323,155.265l-3.951.049-12.271.147-35.931.417-.92-2.454,36.287-.54,16.026-.233.749,2.552Z",
    transform: "translate(-572.668 -124.35)",
    fill: "#2d4180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34566",
    "data-name": "Path 34566",
    d: "M586.47,158.734l-11.658-29.145h36.508l11.351,28.838Z",
    transform: "translate(-574.812 -129.589)",
    fill: "#243466"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34567",
    "data-name": "Path 34567",
    d: "M626.655,155.314l3.939-.11-.749-2.552-16.027.233.564,2.577Z",
    transform: "translate(-565.951 -124.35)",
    fill: "#425799"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34568",
    "data-name": "Path 34568",
    d: "M601,85.232V82.2l8.9-.169.614,3.375Z",
    transform: "translate(-555.288 -67.846)",
    fill: "#ffad80",
    opacity: 0.62
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanWorking);
export default __webpack_public_path__ + "static/media/woman-working.a95f1d89575d824368d21ec1e77c711f.svg";
export { ForwardRef as ReactComponent };